export function useSwipeEvents(element) {
    let touchStartX = 0;
    let touchStartY = 0;
    let touchEndX = 0;
    let touchEndY = 0;
    const threshold = 50;

    function handleSwipe() {
        const xDiff = touchEndX - touchStartX;
        const yDiff = touchEndY - touchStartY;

        const xDelta = Math.abs(xDiff);
        const yDelta = Math.abs(yDiff);

        if (xDelta > yDelta) {
            if (xDiff < 0 && xDelta > threshold) {
                element.dispatchEvent(new CustomEvent('swipe-left'));
            }
            if (xDiff > 0 && xDelta > threshold) {
                element.dispatchEvent(new CustomEvent('swipe-right'));
            }
        } else {
            if (yDiff < 0 && yDelta > threshold) {
                element.dispatchEvent(new CustomEvent('swipe-up'));
            }
            if (yDiff > 0 && yDelta > threshold) {
                element.dispatchEvent(new CustomEvent('swipe-down'));
            }
        }
    }

    element.addEventListener('touchstart', (event) => {
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
    });

    element.addEventListener('touchend', (event) => {
        touchEndX = event.changedTouches[0].clientX;
        touchEndY = event.changedTouches[0].clientY;
        handleSwipe();
    });
}